import createCache from "@emotion/cache";

// Force consistent emotion cache configuration
// This prevents hydration mismatches by using the same key and options
function createEmotionCache() {
    return createCache({
        key: "css", // Use 'css' to match what's expected on server
        prepend: true,
    });
}

export default createEmotionCache;
